import type {
  ListTargetProbeStateResponse,
  ProbeTargetNowRequest,
  ProbeTargetNowResponse,
  ResetTargetProbeRequest,
  ResetTargetProbeResponse,
  TryTargetProbeRequest,
  TryTargetProbeResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE = '/v1/ops/target-probes';

export async function listTargetProbes(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListTargetProbeStateResponse> {
  return opsApiRequest<ListTargetProbeStateResponse>(BASE, { signal }, fetchImpl);
}

export async function resetTargetProbe(
  body: ResetTargetProbeRequest,
  fetchImpl: typeof fetch,
): Promise<ResetTargetProbeResponse> {
  return opsApiRequest<ResetTargetProbeResponse>(
    `${BASE}/reset`,
    { method: 'POST', body },
    fetchImpl,
  );
}

export async function probeTargetNow(
  body: ProbeTargetNowRequest,
  fetchImpl: typeof fetch,
): Promise<ProbeTargetNowResponse> {
  return opsApiRequest<ProbeTargetNowResponse>(
    `${BASE}/probe-now`,
    { method: 'POST', body },
    fetchImpl,
  );
}

/** One side-effect-free shot (tenant-routing 试打); nothing about routing changes. */
export async function tryTargetProbe(
  body: TryTargetProbeRequest,
  fetchImpl: typeof fetch,
): Promise<TryTargetProbeResponse> {
  return opsApiRequest<TryTargetProbeResponse>(
    `${BASE}/try`,
    { method: 'POST', body },
    fetchImpl,
  );
}
